import type { Root } from 'mdast';
import { visit } from 'unist-util-visit';

import { $remark } from '@milkdown/kit/utils';
import directive from 'remark-directive';

/**
 * Registers remark-directive in Milkdown's remark pipeline.
 * This enables parsing of ::leafDirective{attr="val"} syntax.
 */
export const remarkDirectivePlugin = $remark(
    'remarkDirective',
    () => directive
);

/**
 * Converts textDirective nodes (e.g. `:7`, `:foo`) back to plain text
 * so they don't crash Milkdown's parser which only handles leafDirective.
 */
function stripTextDirectives() {
    return (tree: Root) => {
        visit(tree, 'textDirective', (node, index, parent) => {
            if (index == null || !parent) return;
            parent.children.splice(index, 1, {
                type: 'text',
                value: `:${(node as unknown as { name: string }).name}`
            });
        });
    };
}

export const remarkStripTextDirectivesPlugin = $remark(
    'remarkStripTextDirectives',
    () => stripTextDirectives
);
